
import Slider from "react-slick";
import Productlist from "./Productlist";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container } from "react-bootstrap";
import React, {useState, useEffect} from "react"

export default function Topproducts() {
  const [article, setArticle] = useState([]);

  const getData = () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      // body: formBody
    };
    let url = "https://fakestoreapi.com/products";
    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        // console.log("DATA IS", response);
        setArticle(response);
      })
      .catch((error) => {
        console.log("Error is", error);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <>
      <div className="top-games pt-5 pb-5">
        <h2 className="text-center text-white font-700 mb-5">
          TOP WORLD GAMES
        </h2>

        <Container fluid>
          <Slider {...settings}>
            {article.map((data, index) => {
              // console.log("ALL DATA",data)
              return (
                <div className="products-item">
                  <Productlist key={index} articles={data} />
                </div>
              );
            })}
          </Slider>
        </Container>
      </div>
    </>
  );
}
